import React from 'react';
import {connect} from "react-redux";

import {Link} from 'react-router-dom';

import {
    CardContainer,
    Notification,
    Loading,
    Button,
    Dialog,
    Input,
    Validator,
    IconButton
} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

import {convertDigitsToStandard} from 'services/converts/numbers';
import {LessonApi} from 'services/network/api';


class LessonsTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: props.courseId,
            data: undefined,
            loading: true,
            showAddDialog: false,
            lessonName: '',
            createBtnLoading: false,
            unsavedDescription: '',
            descriptionEditMode: false,
            descriptionSubmitLoading: false
        };

        this.validator = Validator(props.locale.abbreviation);

    }

    componentDidMount() {
        const res = this.checkCourseId();
        if (!res) {
            Notification('error', 'WrongData');
            return;
        }

        this.loadData();
    }

    checkCourseId() {
        const {courseId} = this.props;
        if (courseId) {
            this.setState({courseId});
            return true;
        }
        return false;
    }

    loadData() {
        //Todo: use loading
        const {courseId} = this.state;
        LessonApi.GetAdminByCourseId(courseId)
            .then(res => {
                if (res && res.status == 200) {
                    this.setState({data: res.data});
                }
            }).finally(() => {
            this.setState({loading: false});
        })
    }

    inputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    handleSubmitAddClick = () => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson;

        let validationResult = true;
        validationResult = this.validator.fieldValid(pageTranslates.LessonName);

        if (validationResult) {
            this.setState({createBtnLoading: true});
            const {courseId, lessonName} = this.state;
            const model = {courseId: parseInt(courseId), title: lessonName};

            LessonApi.Create(model)
                .then(res => {
                    if (res.status == 200) {
                        this.loadData();
                        Notification('success', 'Succeed');
                        this.setState({showAddDialog: false});
                    }
                })
                .finally(x => {
                    this.setState({createBtnLoading: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({createBtnLoading: false});
        }
    };

    handleEditDescriptionOnClick = () => {
        const {data} = this.state;
        const {description} = data;

        this.setState({descriptionEditMode: true, unsavedDescription: description});
    };

    handleSubmitDescriptionEdit = () => {
        const {courseId, unsavedDescription} = this.state;
        const model = {CourseId: parseInt(courseId), Description: unsavedDescription};
        this.setState({descriptionSubmitLoading: true});
        LessonApi.UpdateLessonDescription(model)
            .then(res => {
                if (res && res.status == 200) {
                    Notification('success', 'Succeed');
                    let {data} = this.state;
                    data.description = unsavedDescription;
                    this.setState({data, descriptionEditMode: false});
                }
            }).finally(() => {
            this.setState({descriptionSubmitLoading: false});
        });
    };

    handleCancelDescriptionEdit = () => {
        this.setState({descriptionEditMode: false, unsavedDescription: ''});
    };

    render() {
        const {data, loading, showAddDialog, lessonName, createBtnLoading, descriptionEditMode, unsavedDescription, descriptionSubmitLoading} = this.state;

        if (loading)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson;


        const {description, lessons} = data;
        //show data
        return (
            <>
                <div className='m-3'>
                    <Button full type='success' shadowType='sm' onClick={() => {
                        this.setState({showAddDialog: true})
                    }}>
                        <i className='fa fa-plus font-weight-bold ml-2'/>
                        <span className='font-weight-bold font-14'>
                                    {pageTranslates.Create}
                    </span>
                    </Button>
                </div>

                {!data || !data.courseId || data.lessons && data.lessons.length == 0 ?
                    <NoRecord message='CourseLesson'/>
                    :
                    <CardContainer>
                        <div className='d-flex align-items-center'>
                            {descriptionEditMode ?
                                <>
                                    <Input className='font-13'
                                           placeholder={pageTranslates.Description} value={unsavedDescription}
                                           onChange={this.inputChange('unsavedDescription')}/>
                                    <IconButton icon='check' iconStyle={{color: 'darkgreen', fontSize: 12}}
                                                onClick={this.handleSubmitDescriptionEdit}
                                                loading={descriptionSubmitLoading}/>
                                    <IconButton icon='times' iconStyle={{color: 'darkred', fontSize: 12}}
                                                onClick={this.handleCancelDescriptionEdit}/>
                                </>
                                :
                                <>
                                    <IconButton icon='cog' iconStyle={{fontSize: 12}}
                                                onClick={this.handleEditDescriptionOnClick}/>
                                    <p className='font-13'>
                                        {description || pageTranslates.NoDescription}
                                    </p>
                                </>
                            }
                        </div>

                        <div className="list-group list-custom-small">
                            {lessons.map((item, index) => {
                                const number = index + 1;
                                const {title} = item;
                                return (
                                    <Link to={`lesson?lessonId=${item.id}`}>
                                        <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal'}}>
                                            {number}
                                        </i>
                                        <span className='float-right'>
                                    {title}
                                </span>
                                        <i className="fa fa-angle-left"></i>
                                    </Link>
                                );
                            })}
                        </div>
                    </CardContainer>
                }


                <Dialog open={showAddDialog} title={pageTranslates.Create}>
                    <div>
                        <div>
                            <label className='mb-0 color-primary'>
                                {pageTranslates.LessonName}
                            </label>
                            <Input placeholder={pageTranslates.LessonName} value={lessonName}
                                   onChange={this.inputChange('lessonName')}
                            />
                            {this.validator.message(pageTranslates.LessonName, lessonName, 'required|min:3')}
                        </div>
                        <div>
                            <Button full onClick={this.handleSubmitAddClick} loading={createBtnLoading}>
                                {pageTranslates.CreateDialog.Submit}
                            </Button>
                            <Button full type='secondary' onClick={() => this.setState({showAddDialog: false})}>
                                {pageTranslates.CreateDialog.Cancel}
                            </Button>
                        </div>
                    </div>
                </Dialog>

            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(LessonsTab);

